import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const RedoIcon = withSvgIcon(
    <g>
        <path d="M325.8 117.4l138.5 117.5-136.2 114.3v-56.1l-18.2-3.9c-1.5-.3-36.2-7.6-81.8-7.6-55.3 0-130.8 11-179.5 63 .9-2.6 1.8-5.2 2.8-7.8 10.7-29.9 22.4-55.4 34.8-75.9 14.5-23.9 29.5-40.6 44.7-49.4 24.2-14.1 53.2-24.4 86.1-30.5 27.9-5.2 52.5-6.3 68.3-6.3 10 0 15.9.4 16 .4l25 2-.2-25.1-.3-34.6m-23.4-50l.7 84.8s-6.6-.5-17.8-.5c-32.8 0-105.2 4.5-166 39.9C37.9 239 1.2 430.8 1.2 430.8s-1.4 1.8-1.2 1.8c.5 0 9.6-9.2 62.8-69.5 42.3-47.9 111.6-58.6 165.3-58.6 43.7 0 77 7.1 77 7.1v86.8L500 235 302.4 67.4z" />
    </g>
);
